<template>
  <div class="dashboard">
    <loading ref="aLoadScreen" />
    <header-navigation :enableNoBorder="true"/>
    <div class="container" style="justify-content: center; align-items: center;">
      <oops ref="aOops" />
      <error ref="aError" />
      <n-r-l-chart ref="aNRL" style="width: 100vw;" :style="{height: showDownload ? '80vh' : '100vh'}"/>
      <button @click="downloadCSV" class="singleRowFlex downloadLink" style="cursor: pointer;" v-if="NRLData && showDownload">
        <img class="icon" :src="require('@/assets/icons/download.svg')" alt="download" />
        <p class="link">Download NRL Data</p>
      </button>
    </div>
    <bottom-credits style="margin-top: 0;" :enableNoBorder="true"/>
  </div>
</template>

<script>
  import axios from 'axios';
  import NRLChart from "../components/NRL/NRLChart.vue";
  import Loading from "../components/Loading.vue";
  import BottomCredits from "../components/BottomCredits.vue";
  import HeaderNavigation from "../components/HeaderNavigation.vue";
  import Oops from "../components/Oops.vue";
  import Error from "../components/Error.vue";

  export default {
    name: "NRL",
    components: {
      NRLChart,
      Loading,
      BottomCredits,
      HeaderNavigation,
      Oops,
      Error
    },
    data: () => ({
      NRLData: null,
      showDownload: true,
      showLoading: true
    }),
    mounted() {
      var globv = this;
      globv.checkLoading();
      globv.startUp();
      globv.checkNoBorder();
    },
    methods: {
      startUp: async function() {
        var globv = this;
        if (globv.showLoading)
          globv.$refs.aLoadScreen.startLoading();
        let operator = globv.$route.params.operator;
        try {
          let response = await axios.get('/api/nrl/operator/' + operator);

          if (response["data"]) {
            globv.NRLData = response["data"]['data'];
            globv.$refs.aNRL.createChart(response["data"]);

            if (globv.showLoading)
              setTimeout(globv.$refs.aLoadScreen.finishLoading, 100);
          }
        }
        catch (error) {
          globv.handleError(error);
        }
      },
      handleError: function(error) {
        var globv = this;
        console.log(error, error.response);
        if (error && error.response && error.response.data)
          error = error.response.data;
        if (error["error"] && error["error"]["status"] < 500) {
          if (error["error"]["status"] == 404)
            globv.$refs.aError.showError({
              status: 404,
              title: "Not Found",
              message: error["error"]["message"]
            });
          else
            globv.$refs.aError.showError({
              status: error["error"]["status"],
              message: error["error"]["message"]
            });
        }
        else globv.$refs.aOops.showOops();

        if (globv.showLoading)
          setTimeout(globv.$refs.aLoadScreen.finishLoading, 100);
      },
      downloadCSV: function() {
        var globv = this;

        let formatData = [{
            varName: "speed",
            labelName: "Speed",
            unit: "m/s"
          },
          {
            varName: "location",
            labelName: "Locaton"
          }
        ];

        let csvData = "Time";
        // add variable names
        for (let format in formatData) {
          csvData +=
            "," +
            formatData[format]["labelName"] +
            " (" +
            formatData[format]["unit"] +
            ")";
        }
        csvData += "\n";

        for (let a of globv.NRLData) {
          csvData += (new Date(a['time'])).toLocaleString().replace(',', '');
          for (let format in formatData) {
            csvData += "," + a[formatData[format]['varName']];
          }
          csvData += "\n";
        }

        let name = globv.$route.params.operator + "_NRL.csv";

        let blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        let url = URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      checkNoBorder: function() {
        var globv = this;
        if (![null, undefined].includes(globv.$route.query.noborder)) {
          let bool = globv.$route.query.noborder.toLowerCase() == 'true' ? true : false;
          globv.showDownload = !bool;
        }
        else {
          globv.showDownload = true;
        }
        setTimeout(globv.$refs.aNRL.reflow, 0);
      },
      checkLoading: function() {
        var globv = this;
        if (![null, undefined].includes(globv.$route.query.loading)) {
          let bool = globv.$route.query.loading.toLowerCase() == 'false' ? false : true;
          globv.showLoading = bool;
        }
        else {
          globv.showLoading = true;
        }
      }
    },
    watch: {
      '$route.params.station': function() {
        var globv = this;
        globv.startUp();
      },
      '$route.query.noborder': function() {
        var globv = this;
        globv.checkNoBorder();
      },
      '$route.query.loading': function() {
        var globv = this;
        globv.checkLoading();
      }
    }
  };
</script>
